import { render, staticRenderFns } from "./DocumentInfo.vue?vue&type=template&id=3050a791&scoped=true"
import script from "./DocumentInfo.vue?vue&type=script&lang=js"
export * from "./DocumentInfo.vue?vue&type=script&lang=js"
import style0 from "./DocumentInfo.vue?vue&type=style&index=0&id=3050a791&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3050a791",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3050a791')) {
      api.createRecord('3050a791', component.options)
    } else {
      api.reload('3050a791', component.options)
    }
    module.hot.accept("./DocumentInfo.vue?vue&type=template&id=3050a791&scoped=true", function () {
      api.rerender('3050a791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/DocumentInfo.vue"
export default component.exports